"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
const validFileExtensions = [".mp3", ".ogg", ".srt", ".vtt", ".mp4"];
exports.downloadFile = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/file/download",
    alias: "downloadFile",
    parameters: [
        {
            name: "url",
            description: "Amazon S3 FileURL to download",
            type: "Query",
            schema: zod_1.z
                .string()
                .url()
                .refine((url) => validFileExtensions.some((ext) => url.endsWith(ext)), {
                message: "Not a valid file extension",
            }),
        },
    ],
    response: zod_1.z.instanceof(Uint8Array),
});
//# sourceMappingURL=download.js.map